import { queryKeys } from "@lib/api/queryKeys";
import { useMercure } from "@lib/hooks/useMercure";
import { useToast } from "@lib/hooks/useToast";
import { useQueryClient } from "@tanstack/react-query";

/**
 * Subscribe to real-time ticket collection invalidations via Mercure.
 *
 * Topic selection is EXACT (Mercure matches subscriptions against the update's
 * topic as URI templates — there is no substring matching). This hook listens
 * on the collection topic `/api/tickets` only, so it receives collection-level
 * signals (`collection.invalidate`), NOT entity events on `/api/tickets/{id}`.
 * Invalidating `tickets.all` refetches every mounted ticket query (list, detail,
 * comments, attachments, metrics), which is what a collection invalidation asks for.
 */
export function useTicketSubscription() {
  const queryClient = useQueryClient();
  const toast = useToast();

  useMercure("/api/tickets", {
    onMessage: () => {
      // Invalidate all ticket queries (list, detail, comments, attachments, metrics)
      queryClient.invalidateQueries({ queryKey: queryKeys.tickets.all });
    },
    onError: (error: Error) => {
      toast.error("Erreur de connexion Mercure — les mises à jour en temps réel sont interrompues");
    },
  });
}
